function HistoryFixtureResultCard({ fixture }) {
    const getOutcomeStyles = (outcome) => {
      const normalized = (outcome || "").toLowerCase();
  
      if (normalized === "exact") {
        return "bg-emerald-100 text-emerald-700";
      }
  
      if (normalized === "correct") {
        return "bg-amber-100 text-amber-700";
      }
  
      if (normalized === "incorrect") {
        return "bg-rose-100 text-rose-700";
      }
  
      return "bg-slate-100 text-slate-700";
    };
  
    const formatScore = (home, away) => {
      if (home === null || home === undefined || away === null || away === undefined) {
        return "—";
      }
  
      return `${home} - ${away}`;
    };
  
    const formatKickoff = (kickoffUtc) => {
      return new Date(kickoffUtc).toLocaleString([], {
        dateStyle: "medium",
        timeStyle: "short",
      });
    };
  
    return (
      <div className="rounded-3xl bg-white p-5 shadow-sm ring-1 ring-slate-200">
        <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="text-sm font-semibold text-slate-900">
              {fixture.homeTeamName} vs {fixture.awayTeamName}
            </p>
            <p className="mt-1 text-sm text-slate-500">
              {formatKickoff(fixture.kickoffUtc)}
            </p>
          </div>
  
          <div className="flex items-center gap-2">
            <span
              className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${getOutcomeStyles(
                fixture.outcome
              )}`}
            >
              {fixture.outcome || "Pending"}
            </span>
  
            <span className="inline-flex rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
              {fixture.pointsAwarded} pts
            </span>
          </div>
        </div>
  
        <div className="grid gap-3 md:grid-cols-2">
          <div className="rounded-2xl bg-slate-50 p-4">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Actual Result
            </p>
            <p className="mt-2 text-base font-semibold text-slate-900">
              {formatScore(fixture.actualHomeScore, fixture.actualAwayScore)}
            </p>
          </div>
  
          <div className="rounded-2xl bg-slate-50 p-4">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Your Prediction
            </p>
            <p className="mt-2 text-base font-semibold text-slate-900">
              {formatScore(fixture.predictedHomeScore, fixture.predictedAwayScore)}
            </p>
          </div>
        </div>
      </div>
    );
  }
  
  export default HistoryFixtureResultCard;